module.exports = __webpack_public_path__ + "media/images/country_flags/zz-8bff03bbf038d6d02c72af01b48b07d1.png";